import {
    valInDeep,
    getParent
} from '@/library/js/array.js';
/**
 * auth: sshu
 * time: 2020.04.30
 * des: 工具类
 */
function routerGo(href = '/', title = null, stateObj = {}) {
    window.history.replaceState(stateObj, title, href);
}

/*
 *获取参数
 */
function getQueryString(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return decodeURI(r[2]);
    return null;
}

/**
 * 将浮点数取小数点后1位
 */
function toDecimal(val) {
    var f = parseFloat(val);
    if (isNaN(f)) {
        return;
    }
    f = Math.floor(val * 10) / 10;
    return f;
}

/*
 *文件大小转换
 */
function bytesToSize(bytes) {
    let k = 1024, // or 1024
        sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    for (let j = 0; j < sizes.length; j++) {
        if (String(bytes).indexOf(sizes[j]) >= 0) return bytes;
    }
    if (bytes === 0) return '0 B';

    let i = Math.floor(Math.log(bytes) / Math.log(k));
    return (bytes / Math.pow(k, i)).toPrecision(3) + ' ' + sizes[i];
}

/*
 *阿拉伯数字转中文数字
 */
function intToChinese(str) {
    str = str + '';
    var len = str.length - 1;
    var idxs = ['', '十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千', '万', '十', '百', '千', '亿'];
    var num = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
    return str.replace(/([1-9]|0+)/g, function ($, $1, idx, full) {
        var pos = 0;
        if ($1[0] != '0') {
            pos = len - idx;
            if (idx == 0 && $1[0] == 1 && idxs[len - idx] == '十') {
                return idxs[len - idx];
            }
            return num[$1[0]] + idxs[len - idx];
        } else {
            var left = len - idx;
            var right = len - idx + $1.length;
            if (Math.floor(right / 4) - Math.floor(left / 4) > 0) {
                pos = left - left % 4;
            }
            if (pos) {
                return idxs[pos] + num[$1[0]];
            } else if (idx + $1.length >= len) {
                return '';
            } else {
                return num[$1[0]]
            }
        }
    });
}

/**
 *获取文件后缀名
 * @param filename
 * @returns {string}
 */
function get_suffix(filename) {
    let pos = filename.lastIndexOf('.');
    let suffix = '';
    if (pos !== -1) {
        suffix = filename.substring(pos)
    }
    return suffix;
}

/**
 *打开新的窗体
 */
function openNewPage(vm, name, argu, query) {
    let pageOpenedList = vm.$store.state.app.pageOpenedList;
    let openedPageLen = pageOpenedList.length;
    let i = 0;
    let tagHasOpened = false;
    while (i < openedPageLen) {
        if (name === pageOpenedList[i].name) { // 页面已经打开
            vm.$store.commit('pageOpenedList', {
                index: i,
                argu: argu,
                query: query
            });
            tagHasOpened = true;
            break;
        }
        i++;
    }
    if (!tagHasOpened) {
        let tag = vm.$store.state.app.tagsList.filter((item) => {
            return name === item.name;
        });
        tag = tag[0];
        if (tag) {
            if (argu) {
                tag.argu = argu;
            }
            if (query) {
                tag.query = query;
            }
            vm.$store.commit('increateTag', tag);
        }
    }
    vm.$store.commit('setCurrentPageName', name);
}

function matchingUrl(url) {
    return url.match(/http[s]?:\/\/(.*?)([:\/]|$)/);
}

/**
 * 设置头部面包屑导航
 */
function setCurrentPath(vm, path, argu, isTibetanLanguage = false) {
    let currentPathArr = [];
    //第一步获取当前选择的菜单
    let targetMenu = valInDeep(vm.$store.getters.menus, path, 'path', 'children');
    //第二步将菜单集合和当前选中的菜单集合 通过match字段匹配菜单集合内的完整面包屑
    if (targetMenu.length > 0) {
        let parentMenu = getParent(vm.$store.getters.menus, targetMenu[0].id, 'parentId');
        if (parentMenu.length > 0) {
            parentMenu.forEach((item, index) => {
                currentPathArr.push({title: item.title, path: item.path, params: argu, isLink: false})
            });
        }
        if (currentPathArr.length > 0) {
            vm.$store.dispatch("menu/setCurrentPath", currentPathArr);
        }
    }
}

function deepCopy(obj) {
    if (typeof obj != 'object') {
        return obj;
    }
    var newobj = {};
    for (var attr in obj) {
        newobj[attr] = this.deepCopy(obj[attr]);
    }
    return newobj;
}

/**
 * 获取域名部分
 * @param str
 */
function domainURI(str) {
    let urlReg = /[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\.?/;
    return urlReg.exec(str);
}

/**
 * 随机生成guid
 */
function getUuid() {
    var s = [];
    var hexDigits = "0123456789abcdef";
    for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    // bits 12-15 of the time_hi_and_version field to 0010
    s[14] = "4";
    // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
    s[8] = s[13] = s[18] = s[23] = "-";
    var uuid = s.join("");
    return uuid;
}

/**
 * 跳转到公共下载页的公共方法
 *
 */
function gotoDownloadpage(queryObj) {
    let url = '/base/downloadList?';

    let queryStr = '';
    Object.keys(queryObj).forEach((key) => {
        queryStr += key + '=' + queryObj[key] + '&';
    });

    if (queryStr != '') {
        queryStr = queryStr.substring(0, queryStr.length - 1);
    }
    url = url + queryStr;
    console.log(url);

    this.routerGo(url, '下载');
}

/**
 * 获取学校来源
 *
 */
// function getSchoolOrigin(type) {
//     let schoolOrigin = '';
//     switch (type) {
//         case 1:
//             schoolOrigin = "本系统";
//             break;
//         case 2:
//             schoolOrigin = "一起作业";
//             break;
//         case 3:
//             schoolOrigin = "火花学院";
//             break;
//         case 4:
//             schoolOrigin = "注册用户生成";
//             break;
//         case 5:
//             schoolOrigin = "一起智慧课堂";
//             break;
//         case 6:
//             schoolOrigin = "沐坤安徽教育云";
//             break;
//         case 7:
//             schoolOrigin = "雨花台";
//             break;
//         case 8:
//             schoolOrigin = "江北";
//             break;
//         case 9:
//             schoolOrigin = "课课练";
//             break;
//         case 10:
//             schoolOrigin = "腾讯智慧校园";
//             break;
//         case 11:
//             schoolOrigin = "南京金陵微校";
//             break;
//         case 12:
//             schoolOrigin = "滇教云";
//             break;
//         case 13:
//             schoolOrigin = "TLT";
//             break;
//     }
//     return schoolOrigin
// }

// /**
//  * 获取用户来源
//  *
//  */
// function getUserOrigin(type) {
//     let userOrigin = '';
//     switch (type) {
//         case 0:
//             userOrigin = "本系统";
//             break;
//         case 1:
//             userOrigin = "一起作业";
//             break;
//         case 2:
//             userOrigin = "火花学院";
//             break;
//         case 3:
//             userOrigin = "一起智慧课堂";
//             break;
//         case 4:
//             userOrigin = "沐坤安徽教育云";
//             break;
//         case 5:
//             userOrigin = "雨花台";
//             break;
//         case 6:
//             userOrigin = "江北";
//             break;
//         case 7:
//             userOrigin = "学生扫码注册";
//             break;
//         case 8:
//             userOrigin = "课课练";
//             break;
//         case 10:
//             userOrigin = "腾讯智慧校园";
//             break;
//         case 11:
//             userOrigin = "南京金陵微校";
//             break;
//         case 12:
//             userOrigin = "滇教云";
//             break;
//         case 13:
//             userOrigin = "TLT";
//             break;
//         case 14:
//             userOrigin = "注册";
//             break;
//     }
//     return userOrigin
// }

// /**
//  * 获取班级来源
//  *
//  */
// function getClassOrigin(type) {
//     let classOrigin = '';
//     switch (type) {
//         case 0:
//             classOrigin = "本系统";
//             break;
//         case 1:
//             classOrigin = "一起作业";
//             break;
//         case 2:
//             classOrigin = "火花学院";
//             break;
//         case 3:
//             classOrigin = "注册用户生成班级";
//             break;
//         case 4:
//             classOrigin = "一起智慧课堂";
//             break;
//         case 5:
//             classOrigin = "沐坤安徽教育云";
//             break;
//         case 6:
//             classOrigin = "雨花台";
//             break;
//         case 7:
//             classOrigin = "江北";
//             break;
//         case 10:
//             classOrigin = "腾讯智慧校园";
//             break;
//         case 11:
//             classOrigin = "南京金陵微校";
//             break;
//         case 12:
//             classOrigin = "滇教云";
//             break;
//         case 13:
//             classOrigin = "TLT";
//             break;
//     }
//     return classOrigin
// }


export {
    routerGo,
    getQueryString,
    toDecimal,
    bytesToSize,
    intToChinese,
    get_suffix,
    openNewPage,
    matchingUrl,
    setCurrentPath,
    deepCopy,
    domainURI,
    getUuid,
    gotoDownloadpage,
    // getSchoolOrigin,
    // getUserOrigin,
    // getClassOrigin
}
